import $ from 'jquery';

export function initTracker(){

  $("[data-title] a").on("click",function(e){

    var $this = $(this);
    var label = $this.parents("[data-title]").attr("data-title");
    var category = $this.parents("[data-title]").attr("data-cluster");
    var postid = $this.parents("[data-title]").attr("data-postid");
    var siteid = $this.parents("[data-title]").attr("data-siteid");
    var evnt = $this.parents("[data-title]").attr("data-event") || 'clicked';

    if(_paq){
      _paq.push(['trackEvent', category, evnt, label, JSON.stringify({
        "postid" : postid,
        "siteid" : siteid
      })]);
    }


  });


}
